import React, { useState, useContext, useEffect } from 'react';
import { addcontext } from '../ContextShare/ContextShare';
import { PiArrowCircleRightLight } from "react-icons/pi";
import { logoutAPI } from '../Services/allApi';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import TokenManager from './TokenManager';
function Sidebar() {
    const { tableSelectedFromSidebar, settableSelectedFromSidebar } = useContext(addcontext);
    const navigate=useNavigate()
    const [user, setUser] = useState({
        user_id: sessionStorage.getItem('user_id')
    });

    const {isGeneral, setisGeneral} = useContext(addcontext);
    const {isSessionOpen, setisSessionOpen} = useContext(addcontext);
    const {isMemberOpen,setIsMemberOpen}=useContext(addcontext);
    const [searchQuery,setsearchQuery]=useState()
    const [matchedData,setMatchedData]=useState([true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true])
    const token = sessionStorage.getItem('access_token');
    const reqHeader = {
        "Content-Type": "application/json", "Authorization": `${token}`
    };

    const logOut = async () => {
        if (window.confirm('Are You Sure You Want to Logout??')) {
            const result = await logoutAPI(user,reqHeader);
            if (result.status === 200) {
                sessionStorage.removeItem('access_token');
                sessionStorage.removeItem('refresh_token');
                sessionStorage.removeItem('user_id');
                sessionStorage.removeItem('tokenExpirationTime');
                // window.location.reload();
                localStorage.removeItem('sel')
                navigate('/skyblue')
            } else {
                toast.info('Logout Unsuccessful');
            }
        }
    };
const [selectedFlag,setselectedFlag]=useState()
    const handleGeneral = () => {
        setisGeneral(!isGeneral);
    };

    useEffect(() => {
        if (!['general', 'event', 'constituency', 'role', 'salutation','reserv','constmap'].includes(tableSelectedFromSidebar)) {
            setisGeneral(false);
        }
    }, [tableSelectedFromSidebar]);
    useEffect(()=>{
        setselectedFlag(localStorage.getItem('sel'))
    },[selectedFlag])

    const handleSessionDropdown=()=>{
    settableSelectedFromSidebar('session')
    setisSessionOpen(!isSessionOpen)
    navigate('/octobersky/session')
    localStorage.setItem('sel','session')

    }
    
    const handelGovaddress=()=>{
        settableSelectedFromSidebar('governorsAddress')
        navigate('/octobersky/governersaddress')
        localStorage.setItem('sel','governorsAddress')

    }

    const handleVideo=()=>{
        settableSelectedFromSidebar('video')
        navigate('/octobersky/video')
        localStorage.setItem('sel','video')

    }

    const handleDash=()=>{
        settableSelectedFromSidebar('home')
        navigate('/octobersky')
        localStorage.setItem('sel','home')

    }

    const handleKLA=()=>{
        settableSelectedFromSidebar('kla')
        navigate('/octobersky/kla')
        localStorage.setItem('sel','kla')

    }

    const handleSMemeberMapping=()=>{
        settableSelectedFromSidebar('membermap')
        navigate('/octobersky/session/member-mapping')
        localStorage.setItem('sel','membermap')

    }

    const handleSSittings=()=>{
        settableSelectedFromSidebar('manageSittings')
        navigate('/octobersky/session/sittings')
        localStorage.setItem('sel','manageSittings')

    }

    const handleSsot=()=>{
        settableSelectedFromSidebar('ssot')
        navigate('/octobersky/members/ssot')
        localStorage.setItem('sel','ssot')

    }

    const handleMembers=()=>{
        settableSelectedFromSidebar('member') 
        navigate('/octobersky/members')
    setIsMemberOpen(!isMemberOpen)
        localStorage.setItem('sel','member')

    }
    
    const handleEvents=()=>{
        navigate('/octobersky/events')
        settableSelectedFromSidebar('event')
        localStorage.setItem('sel','event')

    }

    const handleEBudgetSpeech=()=>{
        navigate('/octobersky/budget-speech')
        settableSelectedFromSidebar('budgetSpeech')
        localStorage.setItem('sel','budgetSpeech')

    }

    const handleRulings=()=>{
        navigate('/octobersky/rulings')
        settableSelectedFromSidebar('rulings')
        localStorage.setItem('sel','rulings')

    }

    const handleConstituency=()=>{
        navigate('/octobersky/constituency')
        settableSelectedFromSidebar('constituency')
        localStorage.setItem('sel','constituency')

    }
    const handlesalutation=()=>{
        navigate('/octobersky/salutation')
        settableSelectedFromSidebar('salutation')
        localStorage.setItem('sel','salutation')

    }
    const handlerole=()=>{
        navigate('/octobersky/role')
        settableSelectedFromSidebar('role')
        localStorage.setItem('sel','role')
    }
    const handleManageAdmins=()=>{
        navigate('/octobersky/manage-admins')
        settableSelectedFromSidebar('admin')
        localStorage.setItem('sel','admin')
    }
    const handleComplaints=()=>{
        navigate('/octobersky/complaints')
        settableSelectedFromSidebar('complaints')
        localStorage.setItem('sel','complaints')
    }
    const handleDbStatus=()=>{
        navigate('/octobersky/dbstatus')
        settableSelectedFromSidebar('dbstatus')
        localStorage.setItem('sel','dbstatus')
    }
    const handleResrvation=()=>{
        navigate('/octobersky/reservation')
        settableSelectedFromSidebar('reserv')
        localStorage.setItem('sel','reserv')
    }
    const handleConstMapping=()=>{
        navigate('/octobersky/constituency-mapping')
        settableSelectedFromSidebar('constmap')
        localStorage.setItem('sel','constmap')
    }
    const handleDocumentation=()=>{
        navigate('/octobersky/documentation')
        settableSelectedFromSidebar('doc')
        localStorage.setItem('sel','doc')
    }

    const handleSearchSideBar = (e) => {
        const query = e.trim().toLowerCase(); // Assuming e is the event object and you're extracting the trimmed lowercase value from it
        setsearchQuery(query); // Assuming setsearchQuery is a function to update state
    
        const queryToMatch = ['dashboard','Manage Kla','Manage sessions','Manage videos','manage members','manage events','Governers address','Budget speech','Rulings','General informations','Manage users','Documentations','database status','Manage sittings','members mappings','ssot','Manage Constituency','Manage Role','Manage Salutation','Manage Reservation','Constituency Mapping'];
        let matchFlags = [];
        let matchedIndexes = [];
    
        queryToMatch.forEach((item, index) => {
            const itemParts = item.toLowerCase().split(','); // Split item into parts to match against
            let isMatched = false;
    
            itemParts.forEach(part => {
                if (part.trim().includes(query)) { // Check if any part includes the query
                    isMatched = true;
                }
            });
    
            matchFlags[index] = isMatched;
            if (isMatched) {
                matchedIndexes.push(index);
            }
            setMatchedData(matchFlags)
        });
    
        console.log('Match flags:', matchFlags); // Array of boolean flags indicating if each item matched
        console.log('Matched indexes:', matchedIndexes); // Array of indexes of matched items
        console.log(queryToMatch.length);
        if(matchedData[14]||matchedData[13]){
            setisSessionOpen(true)
        }
        if(matchedData[15]){
            setIsMemberOpen(true)
        }
        if(matchedData[16]||matchedData[17]||matchedData[18]||matchedData[19]){
            setisGeneral(true)
        }
        if(!e||e==null||e==''){
            setisGeneral(false)
            setisSessionOpen(false)
            setIsMemberOpen(false)
        }
    };

    const handleClearSearch=()=>{
        setMatchedData([true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true])
        setsearchQuery('')
        setisGeneral(false)
        setisSessionOpen(false)
        setIsMemberOpen(false)
    }
    
    return (
       <>
        <div className='w-full md:flex hidden bg-primary p-2 me-2 flex-col text-white overflow-y-scroll hide-scroll-bar ' style={{ height: '87vh' }}>
           <div className='w-full'>

            <div className='flex flex-row w-full gap-2 items-center mb-3 mt-1'>

            <div className='bg-blue-gray-700 rounded-full flex flex-row gap-2 items-center justify-start w-full'>
            <Icon icon="majesticons:search" className='ms-2 text-lg' />
                <input placeholder='eg: manage videos' value={searchQuery} type="text" name="" id="" className='w-full h-8 bg-transparent rounded-full ' onChange={(e)=>handleSearchSideBar(e.target.value)} style={{border: 'none', outline: 'none'}}/>
            </div>

            {searchQuery&&<div onClick={handleClearSearch} className='flex items-center border-2 transform duration-500 ease-in-out hover:bg-red-600 hover:text-white border-red-500 text-red-600 rounded-full px-2 h-8 gap-1 cursor-pointer'>
                <span className='text-sm'>Clear</span>
                <Icon icon="mdi:clear-circle-outline" />

            </div>}

            </div>
            
           <div className='flex flex-col'>
           {matchedData[0]&&<button id='dashboard' className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'home' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`} onClick={handleDash}>
                <i className="fa-solid fa-house me-2 ms-12"></i>
                <span>Dashboard</span>
            </button>}

           { matchedData[1]&&<button id='kla' className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'kla' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`} onClick={handleKLA}>
                <i className="fa-solid fa-list-check me-2 ms-12"></i>
                <span>Manage KLA</span>
            </button>}

            
            {/* <button className={`flex flex-row transform duration-500 ease-in-out ${tableSelectedFromSidebar === 'session' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-5 h-12 items-center rounded-lg`} onClick={e => settableSelectedFromSidebar('session')}>
                <i className="fa-solid fa-list-check me-2 ms-12"></i>
                <span>Manage Session</span>
            </button> */}

            {(matchedData[2])&&<button onClick={handleSessionDropdown} className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out  ${selectedFlag === 'session' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`}>
                <i className="fa-solid fa-list-check me-2 ms-12"></i>
                <span>Manage Sessions</span>
               {!isSessionOpen? <div className='flex justify-end w-10'><Icon icon="mdi:chevron-down" className='text-lg' /></div>
               :
               <div className='flex justify-end w-10'><Icon icon="mdi:chevron-up" className='text-lg' /></div>
               }
            </button>}
            {isSessionOpen&& <div className='flex flex-col justify-start items-start mt-2 gap-3 ms-16 text-sm '>
           {matchedData[14]&& <button onClick={handleSMemeberMapping} className={`${selectedFlag === 'membermap' ? 'text-blue-700' : 'text-white hover:text-blue-600'}`}>Member Mapping</button>}

           {matchedData[13]&&<button onClick={handleSSittings} className={`${selectedFlag === 'manageSittings' ? 'text-blue-700' : 'text-white hover:text-blue-600'}`}>Manage Sittings</button>}

            </div>}

           {matchedData[3]&&<button className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'video' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-2 h-12 items-center rounded-lg`} onClick={handleVideo}>
                <i className="fa-solid fa-photo-film me-2 ms-12"></i>
                <span>Manage Videos</span>
            </button>}

            {matchedData[4]&&<button className={`w-full hover:bg-blue-gray-700 flex flex-row mt-1 h-12 items-center transform duration-500 ease-in-out ${selectedFlag === 'member' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 rounded-lg`} onClick={handleMembers}>
                <i className="fa-solid fa-user-tie me-2 ms-12"></i>
                <span>Manage Members</span>
               {!isMemberOpen? <div className='flex justify-end w-10'><Icon icon="mdi:chevron-down" className='text-lg' /></div>
               :
               <div className='flex justify-end w-10'><Icon icon="mdi:chevron-up" className='text-lg' /></div>}

            </button>}
            {isMemberOpen&& <div className='flex flex-col justify-start items-start mt-2 gap-1 ms-16 text-sm '>
                {matchedData[15]&&<button onClick={handleSsot} className={`${selectedFlag === 'ssot' ? 'text-blue-700' : 'text-white hover:text-blue-600'}`}>SSOT</button>}

            </div>}

            {matchedData[5]&&<button className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'event' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-2 h-12 items-center rounded-lg`} onClick={handleEvents}>
                <i className="fa-solid fa-list-check me-2 ms-12"></i>
                <span>Manage Event</span>
            </button>
}
            {matchedData[6]&&<button className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'governorsAddress' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`} onClick={handelGovaddress}>
                <i className="fa-solid fa-address-book me-2 ms-12"></i>
                <span>Governor's Address</span>
            </button>}

            {matchedData[7]&&<button className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'budgetSpeech' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`} onClick={handleEBudgetSpeech}>
                <i className="fa-solid fa-comments-dollar me-2 ms-12"></i>
                <span>Budget Speech</span>
            </button>}

            {matchedData[8]&&<button className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'rulings' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`} onClick={handleRulings}>
                <i className="fa-solid fa-gavel me-2 ms-12"></i>
                <span>Rulings</span>
            </button>}

           {matchedData[9]&& <button onClick={handleGeneral} className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'general' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`}>
                <i className="fa-solid fa-list-check me-2 ms-12"></i>
                <span>General Information</span>
               {!isGeneral? <div className='flex justify-end w-10'><Icon icon="mdi:chevron-down" className='text-lg' /></div>
               :
               <div className='flex justify-end w-10'><Icon icon="mdi:chevron-up" className='text-lg' /></div>
}
            </button>}
            {isGeneral && <div className='flex flex-col justify-start items-start mt-2 gap-3 ms-16 text-sm'>
                {matchedData[16]&&<button onClick={handleConstituency} className={`${selectedFlag === 'constituency' ? 'text-blue-700' : 'text-white hover:text-blue-600'}`}>Manage Constituency</button>}
                {matchedData[20]&&<button onClick={handleConstMapping} className={`${selectedFlag === 'constmap' ? 'text-blue-700' : 'text-white hover:text-blue-600'}`}>Constituency Mapping</button>}
                {matchedData[17]&&<button onClick={handlerole} className={`${selectedFlag === 'role' ? 'text-blue-700' : 'text-white hover:text-blue-600'}`}>Manage Role</button>}
                {matchedData[18]&&<button onClick={handlesalutation} className={`${selectedFlag === 'salutation' ? 'text-blue-700' : 'text-white hover:text-blue-600'}`}>Manage Salutation</button>}
                {matchedData[19]&&<button onClick={handleResrvation} className={`${selectedFlag === 'reserv' ? 'text-blue-700' : 'text-white hover:text-blue-600'}`}>Manage Reservation</button>}
            </div>}

           {matchedData[10]&& <button className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'admin' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-2 h-12 items-center rounded-lg`} onClick={handleManageAdmins}>
                <i className="fa-solid fa-user-gear me-2 ms-12"></i>
                <span>Manage Users</span>
            </button>}

            {/* {matchedData[11]&&<button className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'complaints' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`} onClick={handleComplaints}>
                <i className="fa-solid fa-comments me-2 ms-12"></i>
                <span>Manage Complaints</span>
            </button>} */}

            {matchedData[12]&&<button className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'dbstatus' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`} onClick={handleDbStatus}>
                <i className="fa-solid fa-database me-2 ms-12"></i>
                <span>Database Status</span>
            </button>}

            {matchedData[11]&&<button className={`w-full hover:bg-blue-gray-700 flex flex-row transform duration-500 ease-in-out ${selectedFlag === 'doc' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-1 h-12 items-center rounded-lg`} onClick={handleDocumentation}>
            <i className="fa-solid fa-book me-2 ms-12"></i>
                <span>Documentations</span>
            </button>}
            

            {matchedData.every(item => !item) && (
    <div className='w-full mt-1 bg-red-500 flex flex-col items-center justify-center rounded-lg gap-3 p-4'>

        <div className={` w-full flex flex-row items-center justify-center gap-2`} >
        <Icon icon="ph:empty-fill" className=' text-lg'/>
        <span>No Results Found</span>
    </div>

    <div onClick={handleClearSearch} className='cursor-pointer bg-black px-4 py-2 rounded-full bg-opacity-10 hover:bg-opacity-30 transform duration-500 ease-in-out flex flex-row gap-2 items-center'>
        <p>Clear search query</p>
        <Icon icon="mdi:clear-circle-outline" className='text-lg '/>
    </div>
    </div>
)}


            {/* <button className={`flex flex-row transform duration-500 ease-in-out ${tableSelectedFromSidebar === 'manageSittings' ? 'text-blue-600' : 'text-white'} hover:text-blue-600 mt-5 h-12 items-center rounded-lg`} onClick={e => settableSelectedFromSidebar('manageSittings')}>
                <i className="fa-solid fa-address-book me-2 ms-12"></i>
                <span>Manage Sittings</span>
            </button> */}
           <hr className='mt-5'/>
            {/* Admin Info */}
            <div className='flex flex-col mt-5 h-12 justify-center items-center'>
                <p className='text-sm'>Admin abc</p>
                <p className='text-sm'>{localStorage.getItem('email')}</p>
            </div>

            {/* Logout Button */}
            <div className='flex flex-row mt-4 h-8 justify-center items-center mb-4'>
                <button className='w-1/2 hover:bg-red-700 flex flex-row h-full rounded-lg justify-center items-center transition duration-500 ease-in-out border border-red-500 text-red-600 hover:text-white shadow-md' onClick={logOut}>
                    Logout
                    <i className="fa-solid fa-power-off ms-2"></i>
                </button>
            </div>
           </div>

           </div>
        </div>

        <TokenManager/>
       </>
    );
}

export default Sidebar;